import { render } from "./createInterventionModal.vue?vue&type=template&id=4e878fda"
import script from "./createInterventionModal.vue?vue&type=script&lang=js"
export * from "./createInterventionModal.vue?vue&type=script&lang=js"

import "./createInterventionModal.vue?vue&type=style&index=0&id=4e878fda&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__